import React from "react";
import { defineBlock } from "@smartfire/gutenberg-react";
import style from "./block.module.scss";

function Block({ next, previous }) {
  return (
    <div className="content-container">
      <div className="block-container">
        <div className={style.block}>
          {previous ? (
            <a className={style.previous} href={previous}>
              Cas client précédent
            </a>
          ) : (
            <div />
          )}
          {next ? (
            <a className={style.next} href={next}>
              Cas client suivant
            </a>
          ) : (
            <div />
          )}
        </div>
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  setup: {
    title: "Next previous Post",
  },
});
